export default {
  created() {
    if (this.$store.state.auth.user.group != "admin")
      return this.$router.push("/not-found")
  }
}